(function ($) {
    $("#filter-icon-yacht").click(function () {
        $("#filter-yacht-world").slideToggle();
        $(".img-arrow-filter-yacht").toggleClass('close-filter');
    });

    $('#sl-manufacturer, #sl-model, #sl-country, #sl-price , #sl-length').change(function () {
        search_post();
    });

    let shiftDown = false;
    $('#ip-search-yacht').keypress(function (e) {
        if (e.keyCode == 13) {
            if ($(this).is(":focus") && !shiftDown) {
                e.preventDefault(); // prevent another \n from being entered
                let value = $(this).val();
                search_post();
            }
        }
    });

    $('#ip-search-yacht').keydown(function (e) {
        if (e.keyCode == 16) {
            shiftDown = true;
        }
    });

    $('#ip-search-yacht').keyup(function (e) {
        if (e.keyCode == 16) {
            shiftDown = false;
        }
        if ($(this).val() == "") {
            search_post();
        }
    });

    function search_post()
    {
        $('.filter-yacht-world-ct').trigger('submit');
    }

})(jQuery);
